import axios from 'axios';
import _ from "lodash";
import {supabaseDataService} from "@/services/supabaseService.js";

const API_URL = import.meta.env.VITE_API_URL;
const VITE_KNOKO_BEARER_TOKEN = import.meta.env.VITE_KNOKO_BEARER_TOKEN;

// Create axios instance with base URL
const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(async (config) => {

    const knokoBearerToken = VITE_KNOKO_BEARER_TOKEN;
    if (knokoBearerToken) {
        config.headers.Authorization = `Bearer ${knokoBearerToken}`;
    }

    console.log('knokoBearerToken----->',knokoBearerToken);

    return config;
});


export const apiService = {
    uploadFile: async (uploadUrl, files, metadata, onProgressCallback) => {
        try {
            const formData = new FormData();
            formData.append('imageData0', files[0]);
            if (files.length == 2) {
                formData.append('imageData1', files[1]);
            }
            formData.append('text', metadata.description);
            formData.append('uid', metadata.uid);
            formData.append('approvestep', 'TRUE');
            formData.append('group_id', metadata.group_id);

            const response = await axios.post(uploadUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + VITE_KNOKO_BEARER_TOKEN,
                },
                onUploadProgress: (progressEvent) => {
                    console.log('--progressEvent--->', progressEvent);
                    if (onProgressCallback) {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        onProgressCallback(percentCompleted);
                    }
                },
            });
            console.log('response.data;----->',response.data);

            return response.data;
        } catch (error) {
            console.error('Error uploading file:', error);
            throw error;
        }
    },

    approveUpload: async (approveUrl, incomingFormdata) => {
        try {
            console.log('--incomingFormdata--->', incomingFormdata);
            const formData = new FormData();
            // formData.append('uid', formdata.uid);
            // formData.append('submission_id', formdata.submission_id);
            // console.log('-formdata.submissionApprove---->', formdata.submissionApprove);
            // formData.append('submissionApprove', formdata.submissionApprove );
            // formData.append('memoryGroup',formdata.memoryGroup);

            Object.keys(incomingFormdata).forEach(key => {
                formData.append(key, incomingFormdata[key]);
            });

            console.log('--formData--->', formData);
            const response = await apiClient.post(approveUrl, incomingFormdata);
            return response.data;
        } catch (error) {
            console.error('Error approving upload:', error);
            throw error;
        }
    },

    // Method to send questions to the external API
    askQuestion: async (askUrl, data) => {
        try {
            console.log('[askQuestion] askUrl----->',askUrl);
            console.log('[askQuestion] data----->',data);
            const response = await apiClient.post(askUrl, data);
            console.log('[askQuestion] response----->',response);

            return _.get(response, 'data');
        } catch (error) {
            console.error('Error asking question:', error);
            throw error;
        }
    }
};
